import MyZoidComponent from './widget';

const domElement = document.getElementById('climate_calculator');
if (domElement) {
  const propertyAttr = domElement.attributes['data-property-id'];
  if (propertyAttr && propertyAttr.value) {
    // console.log(
    //   `ClimateCalculator: loading property ${propertyAttr.value} information`
    // );
    MyZoidComponent({
      propertyId: propertyAttr.value,
    }).render('#climate_calculator');
  } else {
    // console.log('ClimateCalculator: property id not found');
  }
} else {
  // console.log(
  //   'ClimateCalculator: skip loading widget, dom element with id #climate_calculator not found'
  // );
}
